import { render, staticRenderFns } from "./UserListView.vue?vue&type=template&id=08c92770&"
import script from "./UserListView.vue?vue&type=script&lang=ts&"
export * from "./UserListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports